import Seo from '@/components/seo';
import './App.scss';

import Routes from '@/routes/index';

function App() {
	return (
		<div className="App">
			<Seo
				title="의도한대로 만드는 개발사"
				description="미스터 디벨로는 기획·디자인·개발을 한 팀이 전담하는 턴키 방식의 IT 외주 개발사입니다. 파라다이스호텔, 현대자동차그룹, LG헬로비전 등 대기업과 5성급 호텔, 20개 이상의 스타트업이 선택한 앱·웹 개발 파트너."
				path="/"
			/>
			<Routes />
		</div>
	);
}

export default App;
